namespace SP.Data {
    export class Package {


        static async getPackageSortingInfo(scan_data: string): Promise<PackageSortingInfo> {
            var response = await SP.post<any>("/api/v1/package/sortingInfo/", encodeURIComponent(scan_data));
            if (response.status == 200) return response.data as PackageSortingInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }



    }

}